import { MenuFoldOutlined } from "@ant-design/icons";
import { Image, Layout, Select, Tag, Tooltip } from "antd";
import UserInfo from "components/UserInfo";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  TAB_SIZE,
} from "constants/ThemeSetting";
import { toggleCollapsedSideNav } from "data/actions";
import {
  fetchLocalGovernmentAreaList,
  fetchStateList,
  setCurrentLga,
  setCurrentPrograms,
  setCurrentState,
} from "data/actions/Common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Auxiliary from "utils/Auxiliary";
import AppConfig from "utils/Config";
import {
  ClientSelectedProgram,
  defaultDebounceTime,
  isNcdcMode,
  UserRoleEnums,
} from "utils/Constant";
import { programEnum } from "utils/Helpers";
import { getCookieValue, setCookieValue } from "utils/Storage";

const { Header } = Layout;
const Option = Select.Option;

const Topbar = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const enlis_program = getCookieValue(ClientSelectedProgram);

  const { navStyle } = useSelector(({ settings }) => settings);
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const { authUser } = useSelector(({ auth }) => auth);
  const { stateList, localGovernmentAreaList } = useSelector(
    ({ common }) => common,
  );

  const [lga, setLga] = useState(null);
  const [activeProgram, setCurrentProgram] = useState(
    enlis_program !== undefined ? enlis_program : "",
  );
  const [lgaOptions, setLgaOptions] = useState([]);
  const [states, setStates] = useState("");

  const {
    // SUPER_ADMIN,
    DATA_ANALYST,
    ADMIN,
    SUPERVISOR,
    MANAGER,
    ANALYST,
    DATA_CLERK,
    RECEPTIONIST,
  } = UserRoleEnums;

  const handleProgramChange = (value) => {
    setCurrentProgram(value);
  };

  /**
   * @function RedirectTo
   * @description Redirects to the specified link
   */
  const RedirectTo = (link) => {
    setTimeout(() => {
      history.push(`/programs/${link}`);
    }, 200);
  };

  const RedirectToClinical = (link) => {
    setTimeout(() => {
      history.push(`/clinical/${link}`);
    }, 200);
  };
  // ======================

  /**
   * @function navigateProgram
   * @description Navigates to the selected program
   */
  const navigateProgram = async () => {
    // ============= ESPN MODULE
    if (activeProgram === programEnum.ESPN) {
      setTimeout(() => {
        history.push(`/espn/dashboard`);
      }, 200);
      return;
    }

    const currentRole = authUser.programs_roles?.find(
      (item) => item?.programs === enlis_program,
    )?.roles;

    if (activeProgram === programEnum.GENERAL && currentRole === ANALYST) {
      RedirectToClinical("workplan");
      return;
    }
    // else if (
    //   activeProgram === programEnum.GENERAL &&
    //   currentRole === MANAGER
    // ) {
    //   RedirectToClinical("dashboard");
    //   return;
    // }
    else if (
      activeProgram === programEnum.GENERAL &&
      currentRole === SUPERVISOR
    ) {
      RedirectToClinical("manage-sample");
      return;
    } else if (
      activeProgram === programEnum.GENERAL &&
      currentRole === DATA_CLERK
    ) {
      RedirectToClinical("lab-order");
      return;
    } else if (
      activeProgram === programEnum.GENERAL &&
      currentRole === RECEPTIONIST
    ) {
      RedirectToClinical("lab-order");
      return;
    } else if (
      activeProgram === programEnum.GENERAL &&
      currentRole === DATA_ANALYST
    ) {
      RedirectToClinical("lab-order");
      return;
    } else if (activeProgram === programEnum.GENERAL && currentRole === ADMIN) {
      setTimeout(() => {
        history.push("/administrations/facility/facilityUsers");
      }, defaultDebounceTime);
      return;
    } else if (activeProgram === programEnum.GENERAL) {
      RedirectToClinical("clinical");
      return;
    }

    // =============  Handle Public Health Laboratory
    const role_obj = authUser?.programs_roles?.filter((obj) => {
      return obj.programs === activeProgram;
    });

    if (role_obj && role_obj[0]?.roles === ADMIN) {
      history.push("/administrations/facility/facilityUsers");
      setTimeout(() => {
        history.push("/administrations/facility/facilityUsers");
      }, 10);
    } else if ([DATA_CLERK, RECEPTIONIST].includes(role_obj?.[0]?.roles)) {
      if (activeProgram === programEnum.TB) {
        RedirectTo("tb-manage-sample");
      } else if (activeProgram === programEnum.EID) {
        RedirectTo("eid-manage-sample");
      } else if (activeProgram === programEnum.VIRAL_LOAD) {
        RedirectTo("vl-manage-sample");
      } else {
        RedirectTo("ph-manage-sample");
      }
    } else if ([SUPERVISOR].includes(role_obj?.[0]?.roles)) {
      if (activeProgram === programEnum.TB) {
        RedirectTo("tb-manage-sample");
      } else if (activeProgram === programEnum.EID) {
        RedirectTo("eid-manage-sample");
      } else if (activeProgram === programEnum.VIRAL_LOAD) {
        RedirectTo("vl-manage-sample");
      } else {
        RedirectTo("ph-manage-sample");
      }
    } else if ([ANALYST].includes(role_obj?.[0]?.roles)) {
      if (activeProgram === programEnum.TB) {
        RedirectTo("tb-workplan");
      } else if (activeProgram === programEnum.EID) {
        RedirectTo("eid-workplan");
      } else if (activeProgram === programEnum.VIRAL_LOAD) {
        RedirectTo("vl-workplan");
      } else {
        RedirectTo("ph-workplan");
      }
      // } else if ([MANAGER].includes(role_obj?.[0]?.roles)) {
      //   if (activeProgram === programEnum.TB) {
      //     RedirectTo("tb-dashboard");
      //   } else if (activeProgram === programEnum.EID) {
      //     RedirectTo("eid-dashboard");
      //   } else if (activeProgram === programEnum.VIRAL_LOAD) {
      //     RedirectTo("vl-dashboard");
      //   } else {
      //     RedirectTo("ph-dashboard");
      //   }
    } else if ([DATA_ANALYST].includes(role_obj?.[0]?.roles)) {
      RedirectTo("ph-dashboard");
    }
  };
  // ======================

  /**
   * @function programs
   * @description Gets the programs from the user object
   */
  // const programs = authUser?.programs_roles?.map((obj) => {
  //   return obj.programs;
  // });
  // const programs = ["General"];
  const programs = [];
  authUser?.programs_roles?.map((obj) => {
    return programs.push(obj?.programs);
  });

  /**
   * @function public_programs
   * @description Gets the Public programs from the user object
   */
  // const public_programs = authUser.programs?.map((item) => {
  //   if (!["EID", "Viral Load", "Tuberculosis"]?.includes(item)) {
  //     return item;
  //   }
  //   return null;
  // });

  // Call the useEffect hook to fetch the states and lga
  useEffect(() => {
    if (authUser.programs_roles?.includes(MANAGER)) {
      dispatch(fetchStateList());
      dispatch(fetchLocalGovernmentAreaList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Call the useEffect hook to set the lga options
  useEffect(() => {
    setLgaOptions(
      localGovernmentAreaList?.filter((lga) => lga.state === states),
    );
    dispatch(setCurrentState(states));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [states]);

  // Call the useEffect hook to set the lga
  useEffect(() => {
    dispatch(setCurrentLga(lga));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lga]);

  setCookieValue(ClientSelectedProgram, activeProgram);
  // let flatPublicPrograms = public_programs?.filter((item) => item);

  // Call the useEffect hook to set the current program and navigate to the program
  useEffect(() => {
    dispatch(setCurrentPrograms(activeProgram));
    navigateProgram();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, activeProgram]);

  // const roles = authUser.programs_roles?.map((item) => {
  //   return item?.roles;
  // });
  const roles = authUser.programs_roles?.map((item) => {
    if (activeProgram && item?.programs === activeProgram) {
      return item?.roles;
    }
    return item?.roles;
  });

  // random color generator based on the string, facility_name and facility_code

  const stringToColour = (arg) => {
    const str = arg?.split(" ")?.join(""); // Remove spaces from facility_name
    const combinedString = str + authUser?.facility_code; // Combine facility_name and facility_code
    let hash = 0;
    for (let i = 0; i < combinedString.length; i++) {
      hash = combinedString.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let j = 0; j < 3; j++) {
      const value = (hash >> (j * 8)) & 0xff;

      // Reduce the brightness by subtracting a fixed value (e.g., 20) from each RGB component
      const darkValue = Math.max(0, value - 65);

      // Convert the darkened value back to a hexadecimal string
      const darkHex = `00${darkValue.toString(16)}`.substr(-2);

      color += darkHex;
    }
    return color;
  };

  return (
    <Header>
      <div className="flex items-center">
        {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED ||
          navStyle === NAV_STYLE_MINI_SIDEBAR) &&
          width < TAB_SIZE) ? (
          <div
            className="gx-linebar gx-mr-3"
            onClick={() => {
              dispatch(toggleCollapsedSideNav(!navCollapsed));
            }}
          >
            <MenuFoldOutlined />
          </div>
        ) : null}

        <Link
          to="#"
          className="gx-d-block gx-d-lg-none gx-pointer gx-mr-2 logo_img"
        >
          <Image
            alt={AppConfig.appName}
            src={AppConfig.logo}
            width={isNcdcMode ? 90 : 50}
            preview={false}
          />
        </Link>

        <div className="gx-mt-lg-3 gx-mt-2 gx-d-md-block gx-d-none">
          {authUser?.facility_name && (
            <Tag
              color={stringToColour(authUser.facility_name)}
              className="my-0"
            >
              <p className="text-white rounded-none px-3 py-0.5 text-lg flex items-center mb-0">
                {authUser.facility_name.length > 25
                  ? `${authUser.facility_name.slice(0, 25)}...`
                  : authUser.facility_name}
              </p>
            </Tag>
          )}
        </div>
      </div>

      <ul className="gx-header-notifications gx-ml-auto">
        {authUser.programs_roles?.roles?.includes(UserRoleEnums.MANAGER) && (
          <div className="hidden">
            <li className="gx-msg">
              <Tooltip placement="left" title="Select State">
                <Select
                  onChange={setStates}
                  placeholder="Select state"
                  className="gx-mb-2 gx-select-sm"
                  defaultValue={states}
                >
                  {stateList?.map((item, i) => (
                    <Option key={i} label={item.name} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Tooltip>
            </li>
            {states && (
              <li className="gx-msg">
                <Tooltip placement="left" title="Select LGA">
                  <Select
                    onChange={setLga}
                    placeholder="Select LGA"
                    className="gx-mb-2 gx-select-sm"
                    defaultValue={lga}
                  >
                    {lgaOptions?.map((item, i) => (
                      <Option key={i} label={item.name} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Tooltip>
              </li>
            )}
          </div>
        )}
        <li className="gx-msg">
          {[
            UserRoleEnums.ADMIN,
            UserRoleEnums.SUPER_ADMIN,
            UserRoleEnums.TIER_USER,
          ].includes(roles?.[0]) ? (
            <small>{activeProgram || ""}</small>
          ) : (
            <Tooltip placement="left" title="Select Program">
              <Select
                onChange={handleProgramChange}
                placeholder="Select Program"
                className="user_topbar_program capitalize"
                defaultValue={activeProgram}
              >
                {programs?.map((item, i) => (
                  <Option key={i} label={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Tooltip>
          )}
        </li>

        <Auxiliary>
          <li className="gx-user-nav">
            <UserInfo stringToColour={stringToColour} />
          </li>
        </Auxiliary>
      </ul>
    </Header>
  );
};
// App Top Header
export default Topbar;
